import React from "react";
import {
  AmplifyAuthenticator,
  AmplifySignIn,
  AmplifySignUp,
} from "@aws-amplify/ui-react";
import { Grid, Paper } from "@mui/material";
import { AppContext } from "AppContext";
import getRouteAndParams from "utils/getRouteAndParams";
import Pdf from "../img/anvandaravtal.pdf";

export default function Login() {
  const appContext = React.useContext(AppContext);
  const isLoggedOn = appContext.authenticated === true;

  React.useEffect(() => {
    //IF we are already logged on, redirect to redirect

    if (isLoggedOn === false) {
      return;
    }
    const params = getRouteAndParams().params;
    if (params.redirectTo) {
      window.location.href = "#" + params.redirectTo;
    }
  }, []);
  return (
    <>
      <Grid
        container
        style={{ backgroundColor: "#0d2532", justifyContent: "center" }}
        justify="center"
      >
        <Grid item md={5}>
          <Paper
            elevation={0}
            square
            style={{ backgroundColor: "#0d2532", margin: "2vh" }}
          >
            <AmplifyAuthenticator usernameAlias="email">
              <AmplifySignIn headerText="Logga in" slot="sign-in" />
              <AmplifySignUp
                headerText="Skapa konto"
                formFields={[
                  {
                    type: "email",
                    label: "Epost *",
                    placeholder: "Ange din epost",
                    required: true,
                  },
                  {
                    type: "password",
                    label: "Lösenord *",
                    placeholder: "Lösenord, minst 6 tecken",
                    required: true,
                  },
                ]}
                slot="sign-up"
                usernameAlias="email"
              >
                <span slot="header-subtitle">
                  Registrera dig för att komma igång med Jojoo!
                  <br />
                  <br /> Du godkänner automatiskt våra{" "}
                  <a href={Pdf} rel="noopener noreferrer" target="_blank">
                    användarvillkor
                  </a>{" "}
                  när ett konto skapas.
                </span>
              </AmplifySignUp>
            </AmplifyAuthenticator>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
